import createIcon from '../../createIcon';

/**
 * @component @name DoorBack
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTlWNUMxOSAzLjkgMTguMSAzIDE3IDNIN0M1LjkgMyA1IDMuOSA1IDVWMTlIM1YyMUgyMVYxOUgxOVpNMTEgMTNIOVYxMUgxMVYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoorBack = createIcon('DoorBack', [
  [
    'path',
    {
      d: 'M19 19V5C19 3.9 18.1 3 17 3H7C5.9 3 5 3.9 5 5V19H3V21H21V19H19ZM11 13H9V11H11V13Z',
      key: '1m1mrk',
    },
  ],
]);

export default DoorBack;
